<template>
  <div class="breadcrumb">
    <div class="inner">
      <template v-for="(item, index) in items">
        <span
          v-if="index < items.length - 1"
          :key="'link-' + index"
          class="link"
          @click="go(item.routeName)"
        >{{ item.title }}</span>
        <span
          v-else
          :key="'current-' + index"
          class="current"
        >{{ item.title }}</span>
        <i
          v-if="index < items.length - 1"
          :key="'sep-' + index"
          class="el-icon-arrow-right"
        />
      </template>
    </div>
  </div>
</template>

<script>
/**
 * PC 端面包屑
 * @prop {Array<{ title: string, routeName: string }>} items 每一层含标题与路由 name；末级仅展示 title，不跳转
 */
export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  methods: {
    go(routeName) {
      if (!routeName) return
      this.$router.push({ name: routeName })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/layout.less';

.breadcrumb {
  background: #fff;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .inner {
    .page-container();
    font-size: 13px;
    color: #999;
    display: flex;
    align-items: center;
    gap: 8px;

    .link {
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        color: #0f5ebf;
      }
    }

    .current {
      color: #333;
    }
  }
}
</style>
